import Container from '@mui/material/Container';
import { useState } from 'react';
import { Step } from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { BaseBreadcrumbs } from '@mgm/common/components/base';
import {
  AssignMembersNav,
  CommissionPlans,
  CommissionPlansMainHeader,
} from '../../features/commissions/components';
import { PageHelmet, TourGuide } from '../../components';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { useAppSelector } from '../../hooks/useAppStore';
import { getCommissionPlans } from '../../store/commissions/selectors';

const CommissionsPage = () => {
  const [runTour, setRunTour] = useState(false);
  const commissionPlans = useAppSelector(getCommissionPlans);
  const { t } = useTranslation(['tour', 'commissions', 'nav']);

  const tourSteps: Array<Step> = [
    {
      target: '#assign-plans',
      disableBeacon: true,
      content: t('useThisOptionToAssignCommission'),
    },
    {
      target: '#assign-orders',
      disableBeacon: true,
      content: t('navigateToTheCommissionedSales'),
    },
    {
      target: '#create-new-plan',
      disableBeacon: true,
      content: t('createANewCommissionPlan'),
    },
    {
      target: '#fixed-plans',
      disableBeacon: true,
      content: t('thisSectionDisplaysTheTotalNumberOfFixed'),
    },
    {
      target: '#steps-plans',
      disableBeacon: true,
      content: t('thisSectionDisplaysTheTotalNumberOfSteps'),
    },
    {
      target: '#team-members-with-plans',
      disableBeacon: true,
      content: t('displaysTheNumberOfTeamMembers'),
    },
    commissionPlans.length && {
      target: '#commission-plan-type',
      disableBeacon: true,
      content: t('indicatesTheTypeOfEachCommissionPlan'),
    },
    commissionPlans.length && {
      target: '#commission-plan-commission',
      disableBeacon: true,
      content: t('displaysTheCommissionSet'),
    },
    commissionPlans.length && {
      target: '#commission-plan-employees',
      disableBeacon: true,
      content: t('displaysTheMembersAssigned'),
    },
  ].filter((x) => !!x);

  const handleStartTour = () => {
    setRunTour(true);
  };

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.COMMISSIONS}>
      <TourGuide steps={tourSteps} run={runTour} onFinish={() => setRunTour(false)} />
      <Container
        sx={{
          px: { xs: 0, lg: 1 },
        }}
        maxWidth={false}
      >
        <BaseBreadcrumbs
          heading={t('commissionPlans', { ns: 'nav' })}
          links={[
            { name: t('commissions', { ns: 'commissions' }), href: '/commissions/plans' },
            { name: t('commissionPlans', { ns: 'nav' }), href: '/commissions/teams' },
          ]}
          action={(
            <CommissionPlansMainHeader handleStartTour={handleStartTour} />
          )}
        />
        <CommissionPlans />
        <AssignMembersNav />
      </Container>
    </PageHelmet>
  );
};

export default CommissionsPage;
